
import * as React from 'react';
import { SetStateAction, Dispatch } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

import { useAppState } from '../reduxish/appState';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function OkDialog() {
    //   const [open, setOpen] = React.useState(false);
    const { state, dispatch } = useAppState();
    const { title, open, text } = state.okDialog;
    // const handleClose = () => {
    //     resetDialogAndHide();
    // };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                slots={{ transition: Transition }}
                keepMounted
                onClose={() => dispatch({ type: 'OK_DIALOG_RESET_AND_HIDE' })}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => dispatch({ type: 'OK_DIALOG_RESET_AND_HIDE' })}>Ok</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}